import { ErrorProvider } from "../shared/ErrorContext";
import { PortalClientContainer } from "../account/PortalClient";

const PortalSite = () => {
  return (
    <div
      className="backPublicSmooth"
      style={{ height: "100vh", display: "flex", flexDirection: "column" }}
    >
      <ErrorProvider>
        <PortalClientContainer />
      </ErrorProvider>
    </div>
  );
};

export default PortalSite;
